import { ClassName, ElementId } from '@type/component-data-types'
import * as React from 'react'

type Props = {
  id?: ElementId
  children: React.ReactNode
  className?: ClassName
  type?: 'supplement'
}

const Box = (props: Props): React.JSX.Element => {
  const requiredCssClass = props.type ? `box ${props.type}` : `box`
  const updateCssClass = props.className
    ? `${requiredCssClass} ${props.className}`
    : requiredCssClass

  return (
    <div id={props.id} className={updateCssClass}>
      {props.children}
    </div>
  )
}
export default Box
